<form [formGroup]="formModel.formGroup">
  <mat-card class="mat-elevation-z4">
    <mat-card-header>
      <img
        src="{{ formModel.profileURL$ | async }}"
        mat-card-avatar
        ngClass.xs="avatar-xs"
        class="card-image"
      />
      <div fxLayout="column" fxFlex="calc(90%-128px);">
        <mat-form-field>
          <mat-label>Name</mat-label>
          <input formControlName="title" matInput placeholder="Business Name" />
          <mat-error *ngFor="let validator of formModel.validators.title">
            <span
              *ngIf="
                formModel.formGroup.controls.title.hasError(validator.type)
              "
            >
              {{ validator.message }}
            </span>
          </mat-error>
        </mat-form-field>
        <mat-form-field
          fxHide
          fxShow.gt-xs
          fxFlex="100"
          fxFlex.gt-xs="calc(50% - 12px)"
        >
          <mat-label>Service Category</mat-label>
          <mat-select required formControlName="type">
            <mat-option
              *ngFor="let type of serviceProviderTypeDescriptions"
              [value]="type.enumValue"
              >{{ type.description }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
    </mat-card-header>
    <mat-card-content>
      <div fxLayout="row" fxLayoutGap="12px" fxLayout="space-around start">
        <mat-form-field fxShow fxHide.gt-xs fxFlex="100">
          <mat-label>Service Category?</mat-label>
          <mat-select required formControlName="type">
            <mat-option
              *ngFor="let type of serviceProviderTypeDescriptions"
              [value]="type.enumValue"
              >{{ type.description }}</mat-option
            >
          </mat-select>
        </mat-form-field>
        <app-tag-selector
          fxFlex="100"
          [options]="formModel.serviceProviderTags$ | async"
          formControlName="tags"
        ></app-tag-selector>
        <mat-form-field fxFlex="100">
          <mat-label>Location</mat-label>
          <mat-chip-list
            #locationList
            formArrayName="locations"
            aria-label="Location selection"
          >
            <mat-chip
              *ngFor="
                let location of locationsFormArray.controls;
                let i = index
              "
              [selectable]="true"
              [removable]="true"
              [formGroupName]="i"
              (removed)="removeLocation(i)"
              color="accent"
            >
              {{ location.value }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
            <input
              [matChipInputFor]="locationList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="true"
              (matChipInputTokenEnd)="addLocation($event)"
            />
          </mat-chip-list>
          <mat-error *ngFor="let validator of formModel.validators.locations">
            <span
              *ngIf="
                formModel.formGroup.controls.locations.hasError(validator.type)
              "
            >
              {{ validator.message }}
            </span>
          </mat-error>
        </mat-form-field>
        <mat-form-field fxFlex="100" class="description-input">
          <mat-label>Description</mat-label>
          <textarea rows="5" formControlName="description" matInput></textarea>
          <mat-error *ngFor="let validator of formModel.validators.description">
            <span
              *ngIf="
                formModel.formGroup.controls.description.hasError(
                  validator.type
                )
              "
            >
              {{ validator.message }}
            </span>
          </mat-error>
        </mat-form-field>
      </div>
    </mat-card-content>
    <mat-card-actions
      fxLayout="column"
      fxLayout.gt-xs="row"
      fxLayoutGap="6px"
      fxLayoutAlign="start stretch"
      fxLayoutAlign.gt-xs="start start"
    >
      <button
        fxFlex="100"
        fxFlex.gt-xs="calc(25%-6px)"
        fxFlexOrder="3"
        fxFlexOrder.gt-xs="1"
        (click)="save()"
        mat-raised-button
        color="primary"
        [class.spinner]="saving"
        [disabled]="saving"
      >
        <mat-icon>save</mat-icon>
        Save
      </button>
      <button
        fxFlex="100"
        fxFlex.gt-xs="50"
        fxFlexOrder="2"
        [class.spinner]="formModel.uploadingFile$ | async"
        [disabled]="formModel.uploadingFile$ | async"
        mat-stroked-button
        color="accent"
        (click)="uploadFile()"
      >
        <mat-icon>file_upload</mat-icon>
        Upload Profile Picture
      </button>
      <button
        fxFlex="100"
        fxFlex.gt-xs="25"
        fxFlexOrder="1"
        fxFlexOrder.gt-xs="3"
        color="warn"
        (click)="delete()"
        *ngIf="formModel.canDelete"
        mat-button
      >
        Delete
      </button>
    </mat-card-actions>
  </mat-card>
  <input
    type="file"
    id="fileUpload"
    name="fileUpload"
    accept="image/*"
    style="display:none;"
  />
</form>
